import {
  useCallback, useEffect, useRef, useState,
} from 'react'

type Resolver = (value: string) => void

function useCancellationReasonModal() {
  const [isOpen, setIsOpen] = useState(false)
  const resolverRef = useRef<Resolver | null>(null)

  const settle = useCallback((value: string) => {
    setIsOpen(false)
    if (resolverRef.current) {
      resolverRef.current(value)
      resolverRef.current = null
    }
  }, [])

  const requestCancellationReason = useCallback(
    (): Promise<string> => new Promise<string>((resolve) => {
      resolverRef.current?.('')
      resolverRef.current = resolve
      setIsOpen(true)
    }),
    [],
  )

  // An unsettled resolver leaves invokeFormAction awaiting forever, which wedges the editor.
  useEffect(() => () => {
    resolverRef.current?.('')
    resolverRef.current = null
  }, [])

  const dismiss = useCallback(() => settle(''), [settle])

  return {
    requestCancellationReason,
    isOpen,
    submit: settle,
    dismiss,
  }
}

export default useCancellationReasonModal
